import React, {useEffect, useRef} from 'react';

import { Link as Scroll } from "react-scroll";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowRight, faArrowLeft, faCircle } from "@fortawesome/free-solid-svg-icons";


//Hero Image
import video from "../assets/heroImages/pltfrmHero2.mp4";

//Graphics
import instagram from "../assets/graphics/Instagram.png"
import tour from "../assets/graphics/tourIcon.png"
import email from "../assets/graphics/email-icon.png"

//TourVideo
import tourVideo from "../assets/tourVideoHomepage.mp4"

//FacilityCarousel Images
import image1 from "../assets/facilityImages/PLTFRM_ourfacility_1.png"
import image2 from "../assets/facilityImages/PLTFRM_ourfacility_2.png";
import image3 from "../assets/facilityImages/PLTFRM_ourfacility_3.png";
import image4 from "../assets/facilityImages/PLTFRM_ourfacility_4.png";
import image5 from "../assets/facilityImages/PLTFRM_ourfacility_5.png";
import image6 from "../assets/facilityImages/PLTFRM_ourfacility_6.png";

//Dylan
import dylan from "../assets/dylanTestimonial.mp4"

//Styles
import "../styling/Header.scss";
import "../styling/HomePage.scss"


const HomePage = ()=>{
    const location = useLocation();
        const elementRef1 = useRef(null);
        const elementRef2 = useRef(null);

    useEffect(
        function () {
            if (location.pathname === "/whypltfrm") {
                elementRef1.current.scrollIntoView({
                    behavior: "smooth",
                });
            } else if (location.pathname === "/ourfacility") {
                elementRef2.current.scrollIntoView({
                    behavior: "smooth",
                });
            }
        },
        [location]
    );

    const images =[image1, image2, image3, image4, image5, image6]
    
    function previousImage(){
        let slider = document.getElementById("slider")
        slider.scrollLeft = slider.scrollLeft - 400;
    }

    function nextImage() {
        let slider = document.getElementById("slider");
        slider.scrollLeft = slider.scrollLeft + 400;
    }

    return (
        <>
            <header className="mainHeader">
                <video
                    src={video}
                    autoPlay
                    muted
                    loop
                    playsInline
                    type="video/mp4"
                    id="myVideo"
                ></video>
                <div className="wrapper">
                    <div className="title">
                        <h1>
                            Toronto's Premier Private Training Gym & Coworking
                            Space
                        </h1>
                        <p>
                            Bringing you a premium space to sweat, work, relax,
                            & connect
                        </p>
                    </div>

                    <div className="arrowContainer">
                        <div className="arrowContainerText">
                            <p>Discover how</p>
                            <div className="logoName"></div>
                            <p>works</p>
                        </div>
                        <div className="arrowHoverContainer">
                            <Scroll
                                to="whyPLTFRM"
                                smooth={true}
                                className="arrowIcon"
                            >
                                <FontAwesomeIcon icon={faArrowDown} />
                                <span className="sr-only sr-only-focusable">
                                    Click to scroll down the page.
                                </span>
                            </Scroll>
                        </div>
                    </div>
                </div>
            </header>
            <section className="whatIsPLTFRM" ref={elementRef1} id="whyPLTFRM">
                <div className="wrapper">
                    <div className="whatIsPLTFRMText">
                        <h2>
                            What is{" "}
                            <span className="titleImportant">PLTFRM?</span>
                        </h2>
                        <p>
                            PLTFRM is a private training gym and coworking space
                            designed to empower personal trainers and fitness
                            professionals in Toronto to grow and run their
                            fitness businesses out of our downtown location.
                        </p>
                        <p>
                            As fitness trainers we want you to be your own boss.
                            What we provide is a physical space with premium
                            equipment, coworking spaces, and community. We
                            promise you premium, exclusive, spacious, and
                            well-designed spaces from which you can run your
                            business on your terms.
                        </p>
                        <p>
                            We are equipped for personal trainers,
                            physiotherapy, nutritionists, massage therapists and
                            so much more. We are always ready to have a
                            conversation on how we can support your business!
                        </p>
                        <p>
                            <strong>
                                Book a tour to check out our facility and find
                                out if PLTFRM is your home.
                            </strong>
                        </p>
                        <div className="buttonContainer">
                            <button>
                                <a href="https://calendly.com/pltfrm-fit/30mintour">
                                    Book a tour
                                </a>
                            </button>
                            <button>
                                <Scroll to="ourfacility" smooth={true}>
                                    Our Facility
                                </Scroll>
                            </button>
                        </div>
                    </div>
                    <video
                        src={dylan}
                        controls
                        playsInline
                        type="video/mp4"
                    ></video>
                </div>
            </section>

            <section className="forFitnessSection">
                <div className="wrapper">
                    <div className="forFitness">
                        <div className="forFitnessProfessionals">
                            <h2>FOR FITNESS PROFESSIONALS</h2>
                            <p>
                                Take your business to the next level. We have a
                                premium facility where you can be your own boss
                                and grow your income.
                            </p>
                            <button>
                                <Link to="/forfitnessprofessionals">
                                    JOIN PLTFRM
                                </Link>
                            </button>
                        </div>
                        <div className="forFitnessEnthusiasts">
                            <h2>FOR FITNESS ENTHUSIASTS</h2>
                            <p>
                                Tired of working out at a crowded gym? Move to
                                PLTFRM and enjoy dedicated space and equipment &
                                boutique style group classes.
                            </p>
                            <button>
                                <Link to="/forfitnessenthusiasts">
                                    EXPLORE BENEFITS
                                </Link>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            <section className="carouselSection" name="ourfacility">
                <div className="wrapper">
                    <h2>Our Facility</h2>
                    <p>
                        We are located at 577 Wellington St W in the heart of
                        downtown,Toronto. We have a two story training facility.
                        We are easily accessible by TTC and are walking distance
                        from major attractions.
                    </p>
                    <div className="facilityCarousel">
                        <button
                            className="carouselButton buttonPrevious"
                            onClick={previousImage}
                        >
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </button>
                        <div className="carouselImage" id="slider">
                            {images.map((image, index) => (
                                <img
                                    src={image}
                                    alt=""
                                    key={index}
                                    className={
                                        index === images.length - 1
                                            ? "slide lastSlide"
                                            : "slide"
                                    }
                                />
                            ))}
                        </div>
                        <button
                            className="carouselButton buttonNext"
                            onClick={nextImage}
                        >
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </div>
                </div>
            </section>
            <section
                className="ourFacilitySection"
                ref={elementRef2}
                id="whyPLTFRM"
            >
                <div className="wrapper">
                    <h2>Our Facility</h2>
                    <div className="ourFacility">
                        <div className="facilityList">
                            <div className="bulletListElement">
                                <FontAwesomeIcon
                                    icon={faCircle}
                                    className="bulletPoint"
                                />
                                <div>
                                    <h4>Top Quality Equipment</h4>
                                    <p>
                                        Each private alcove has its own
                                        dedicated power rack and access to a
                                        functional trainer. Additionally you
                                        have access to a range of equipment
                                        including dumbbells, kettlebells, med
                                        balls, TRX, rowing machine, stationary
                                        bike, bands, and plyo boxes. If we don’t
                                        have something you need we are always
                                        open to having a conversation with you
                                        about acquiring it!
                                    </p>
                                </div>
                            </div>
                            <div className="bulletListElement">
                                <FontAwesomeIcon
                                    icon={faCircle}
                                    className="bulletPoint"
                                />
                                <div>
                                    <h4>Coworking & Lounge Spaces</h4>
                                    <p>
                                        Our coworking & lounge spaces are
                                        designed for you as a fitness
                                        professional. Taking advantage of our
                                        free wifi to get your computer work down
                                        between sessions. Take a private call in
                                        our phone booth. Use our coworking space
                                        to collaborate with other professionals.
                                        Use our coffee corner to treat your
                                        clients before or after a session.
                                    </p>
                                </div>
                            </div>
                            <div className="bulletListElement">
                                <FontAwesomeIcon
                                    icon={faCircle}
                                    className="bulletPoint"
                                />
                                <div>
                                    <h4>Showers & Changing Rooms</h4>
                                    <p>
                                        Our facility is equipped with an
                                        accessible bathroom as well as showers
                                        and changing rooms for you and your
                                        clients. Amenities are cleaned regularly
                                        for your comfort.
                                    </p>
                                </div>
                            </div>
                            <div className="bulletListElement">
                                <FontAwesomeIcon
                                    icon={faCircle}
                                    className="bulletPoint"
                                />
                                <div>
                                    <h4>24/7 Access</h4>
                                    <p>
                                        Part of running your business on your
                                        terms means 24/7 access to our facility.
                                        Design your schedule to work for you. We
                                        are always open for you!
                                    </p>
                                </div>
                            </div>
                            <div className="bulletListElement">
                                <FontAwesomeIcon
                                    icon={faCircle}
                                    className="bulletPoint"
                                />
                                <div>
                                    <h4>Online Booking System</h4>
                                    <p>
                                        All reservations and payments happen
                                        online through our website. You can book
                                        your training sessions in advance to
                                        make sure you get your favorite alcove
                                        every time!
                                    </p>
                                </div>
                            </div>
                            <button>
                                <a href="https://calendly.com/pltfrm-fit/30mintour">
                                    Book a tour
                                </a>
                            </button>
                        </div>
                        <div className="tourVideo">
                            <video src={tourVideo} playsInline controls muted>
                                This video does not support this video
                            </video>
                        </div>
                    </div>
                </div>
            </section>
            <section className="haveAQuestion">
                <div className="wrapper">
                    <h2>
                        Have a question? Checkout our <Link to="/faq">FAQ</Link>
                    </h2>
                </div>
            </section>
            <section className="contactUsSection">
                <div className="wrapper">
                    <h2>Contact Us</h2>
                    <p>
                        Ready to find out if PLTFRM is your home? Get in touch
                        with us and let’s chat about what we can do for you!
                    </p>
                    <div className="contactOptions">
                        <div>
                            <a href="https://www.instagram.com/pltfrm.fit/">
                                <img src={instagram} alt="Instagram icon" />
                                <span className="sr-only sr-only-focusable">
                                    Link to Pltfrm.fit instagram
                                </span>
                            </a>
                            <h4>DM Us</h4>
                            <p>
                                Send us a message <br />
                                on instagram @pltfrm.fit
                            </p>
                        </div>
                        <div className="tourIcon">
                            <a href="https://calendly.com/pltfrm-fit/30mintour">
                                <img src={tour} alt="Tour location icon" />
                                <span className="sr-only sr-only-focusable">
                                    Link to book a tour at our location.
                                </span>
                            </a>
                            <h4>Book a tour</h4>
                            <p>
                                Visit for a free 30 minute tour to check out our
                                space.
                            </p>
                        </div>
                        <div>
                            <a href="mailto: marketing@pltfrm.fit">
                                <img src={email} alt="Email icon" />
                                <span className="sr-only sr-only-focusable">
                                    Link to send marketing@pltfrm.fit an email
                                </span>
                            </a>
                            <h4>Email us</h4>
                            <p>Send us an email at marketing@pltfrm.fit</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
export default HomePage